// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"05375929","252":"cdd8cbd4","302":"aedaf488","304":"bf2a4bac","453":"efa50ee9","462":"d32da429","469":"933b3096","538":"06d201d1","651":"b08146ed","810":"99d471ce","965":"db598b95"}[chunkId] + ".chunk.js";
};